import React from 'react'

const ImageSliderV2 = ({ images, imageRules = 'h-[26px]' }) => {
    return (
        <div
            class="w-full inline-flex gap-8 flex-nowrap overflow-hidden [mask-image:_linear-gradient(to_right,transparent_0,_black_128px,_black_calc(100%-200px),transparent_100%)]">
            <ul class="flex gap-8 items-center justify-center md:justify-start [&_li]:mx-8 [&_img]:max-w-none animate-infinite-scroll">
                {
                    images.map((image, idx) => {
                        return <img src={image.src} alt={image.alt} key={idx} className={imageRules} />
                    })
                }
            </ul>
            <ul class="flex gap-8 items-center justify-center md:justify-start [&_li]:mx-8 [&_img]:max-w-none animate-infinite-scroll" aria-hidden='true'>
                {
                    images.map((image, idx) => {
                        return <img src={image.src} alt={image.alt} key={idx} className={imageRules} />
                    })
                }
            </ul>
        </div>
    )
}

export default ImageSliderV2